import { usePageMeta } from "../hooks/usePageMeta";
import { Header } from "../components/Header";
import { Hero } from "../components/Hero";
import { HowItWorks } from "../components/HowItWorks";
import { Features } from "../components/Features";
import { LoyaltyFeatures } from "../components/LoyaltyFeatures";
import { OperationalFeatures } from "../components/OperationalFeatures";
import { GrowthFeatures } from "../components/GrowthFeatures";
import { PushNotificationFeature } from "../components/PushNotificationFeature";
import { WheelFeature } from "../components/WheelFeature";
import { RoiCalculator } from "../components/RoiCalculator";
import { DashboardPreview } from "../components/DashboardPreview";
import { Coalition } from "../components/Coalition";
import { ReferralProgram } from "../components/ReferralProgram";
import { UseCases } from "../components/UseCases";
import { BookCall } from "../components/BookCall";
import { Pricing } from "../components/Pricing";
import { Faq } from "../components/Faq";
import { FinalCta } from "../components/FinalCta";
import { Footer } from "../components/Footer";

// Hidden from the public site at the owner's request (2026-09-11) — Roue de
// la fortune and Coalition locale are disabled dashboard features, so their
// marketing sections are switched off too. The components are untouched on
// disk; flip this back to true to bring both sections back.
const SHOW_LEGACY_MARKETING = false;

// Hidden at the owner's request (2026-09-12) — the merchant-ambassador
// referral program (parrainage commerçant-à-commerçant, 15% de commission)
// is no longer promoted anywhere on the site. ReferralProgram.tsx and the
// admin commission-tracking tab are left untouched so existing referrers
// already owed a commission keep being tracked correctly.
const SHOW_REFERRAL_PROGRAM = false;

export function Landing() {
  usePageMeta({ title: "Wara Cards — Transformez chaque passage en client fidèle" });
  return (
    <div className="min-h-screen bg-cream">
      <Header />
      <main>
        <Hero />
        <HowItWorks />
        <Features />
        <LoyaltyFeatures />
        <OperationalFeatures />
        <GrowthFeatures />
        <PushNotificationFeature />
        {SHOW_LEGACY_MARKETING && <WheelFeature />}
        <RoiCalculator />
        <DashboardPreview />
        {SHOW_LEGACY_MARKETING && <Coalition />}
        {SHOW_REFERRAL_PROGRAM && <ReferralProgram />}
        <UseCases />
        <BookCall />
        <Pricing />
        <Faq />
        <FinalCta />
      </main>
      <Footer />
    </div>
  );
}
